import { render, staticRenderFns } from "./ArticleEditionView.vue?vue&type=template&id=45fce99a"
import script from "./ArticleEditionView.vue?vue&type=script&lang=js"
export * from "./ArticleEditionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports